export default {
	props:{
		column:{
			type:Object,
			required:true,
		},
		row:{
			type:Object,
			required:true,
		},
		value:{
			
		}
	}
}